module.exports = __webpack_public_path__ + "static/media/test_specialFormatting_override.b87c3ca5.csv";